import { LayerConfig } from '../../config/model/layer-config.model';
import { LayerFactory } from '../util/layer-factory';
import {LayerCode} from "../enum/layer-code.enum";

/**
 * @copyright Schweizerische Bundesbahnen SBB
 * @class StartupInfo
 * @version 0.0.1
 * @since September 2017
 * @description The Layer represents a ESRI-Layer and additional information
 */
export class Layer {
  private _fkLayer: LayerCode;
  private _esriLayer: __esri.Layer;
  private _editable: boolean;
  private _arbeitsBereich: string;
  private _identify: any;
  private _layerUrl: string;
  private _ignoreLayerIds: number[];
  private _popUpInfo: any[];
  private _extension: string;

  constructor(layerConfig: LayerConfig) {
    const { properties } = layerConfig;
    this._esriLayer = LayerFactory.createLayer(layerConfig);
    this._editable = layerConfig.editable;
    this._arbeitsBereich = layerConfig.arbeitsbereich;
    this._identify = layerConfig.identify;
    this._ignoreLayerIds = layerConfig.ignoreLayerIds;
    this._popUpInfo = layerConfig.popUpInfo;
    this._extension = layerConfig.extension;
    this._fkLayer = properties.id;
    this._layerUrl = properties.url;
  }

  public get fkLayer() {
    return this._fkLayer;
  }

  public get editable(): boolean {
    return this._editable;
  }

  public get esriLayer(): __esri.Layer {
    return this._esriLayer;
  }

  public get arbeitsBereich(): any {
    return this._arbeitsBereich;
  }

  public get identify(): any {
    return this._identify;
  }

  public get ignoreLayerIds(): number[] {
    return this._ignoreLayerIds;
  }

  public get popUpInfo(): any[] {
    return this._popUpInfo;
  }

  public get extension(): string {
    return this._extension;
  }

  public get layerUrl(): string {
    return this._layerUrl;
  }
}
